 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"BasketAsset~GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverv~e007f21c":"BasketAsset~GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverv~e007f21c","BasketAsset~PortfolioOverview~PortfolioOverviewIds~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchF~5638f76a":"BasketAsset~PortfolioOverview~PortfolioOverviewIds~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchF~5638f76a","BasketAsset~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchFunds~SearchPensions~SearchStocks":"BasketAsset~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchFunds~SearchPensions~SearchStocks","BasketAsset":"BasketAsset","GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverview~Portfoli~b1a19ea9":"GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverview~Portfoli~b1a19ea9","SearchBenchmarks":"SearchBenchmarks","SearchCryptos":"SearchCryptos","SearchEtfs":"SearchEtfs","SearchFunds":"SearchFunds","SearchPensions":"SearchPensions","SearchStocks":"SearchStocks","GeneratePortfolioAdvanced~PortfolioOverview~PortfolioOverviewIds":"GeneratePortfolioAdvanced~PortfolioOverview~PortfolioOverviewIds","PortfolioOverview":"PortfolioOverview","PortfolioOverviewIds":"PortfolioOverviewIds","GeneratePortfolio":"GeneratePortfolio","GeneratePortfolioAdvanced":"GeneratePortfolioAdvanced","ImportPortfolio":"ImportPortfolio","LoadPortfolio":"LoadPortfolio","admin~auth":"admin~auth","admin":"admin","WelcomePage":"WelcomePage","UserAccountDetail":"UserAccountDetail","auth":"auth","forgotPassword":"forgotPassword","login":"login","register":"register"}[chunkId]||chunkId) + "." + {"BasketAsset~GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverv~e007f21c":"1e5d8a87","BasketAsset~PortfolioOverview~PortfolioOverviewIds~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchF~5638f76a":"80fa59b9","BasketAsset~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchFunds~SearchPensions~SearchStocks":"a02ee52c","BasketAsset":"daff35c6","GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverview~Portfoli~b1a19ea9":"d070da85","SearchBenchmarks":"bcbeface","SearchCryptos":"f7c2c3ee","SearchEtfs":"1b120a26","SearchFunds":"564c5aaa","SearchPensions":"f723ef6c","SearchStocks":"a9714f95","GeneratePortfolioAdvanced~PortfolioOverview~PortfolioOverviewIds":"dec926c7","PortfolioOverview":"dc8226d6","PortfolioOverviewIds":"b8a5d631","GeneratePortfolio":"beabfb08","GeneratePortfolioAdvanced":"385674de","ImportPortfolio":"2ecd1f5e","LoadPortfolio":"25323b71","admin~auth":"08f071b9","admin":"d963d6ea","WelcomePage":"0589da82","UserAccountDetail":"6cb5dec9","auth":"d0ffc947","chunk-1ec5f66a":"fa485861","forgotPassword":"7c167f1b","login":"b191626b","register":"975eb507","chunk-2d216214":"0bbc55e6","chunk-b23a0edc":"2833ddff"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"BasketAsset~PortfolioOverview~PortfolioOverviewIds~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchF~5638f76a":1,"BasketAsset~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchFunds~SearchPensions~SearchStocks":1,"SearchBenchmarks":1,"SearchCryptos":1,"SearchEtfs":1,"SearchFunds":1,"SearchPensions":1,"SearchStocks":1,"GeneratePortfolioAdvanced~PortfolioOverview~PortfolioOverviewIds":1,"PortfolioOverview":1,"PortfolioOverviewIds":1,"GeneratePortfolio":1,"GeneratePortfolioAdvanced":1,"ImportPortfolio":1,"LoadPortfolio":1,"admin":1,"WelcomePage":1,"UserAccountDetail":1,"auth":1,"chunk-1ec5f66a":1,"forgotPassword":1,"login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"BasketAsset~GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverv~e007f21c":"BasketAsset~GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverv~e007f21c","BasketAsset~PortfolioOverview~PortfolioOverviewIds~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchF~5638f76a":"BasketAsset~PortfolioOverview~PortfolioOverviewIds~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchF~5638f76a","BasketAsset~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchFunds~SearchPensions~SearchStocks":"BasketAsset~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchFunds~SearchPensions~SearchStocks","BasketAsset":"BasketAsset","GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverview~Portfoli~b1a19ea9":"GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverview~Portfoli~b1a19ea9","SearchBenchmarks":"SearchBenchmarks","SearchCryptos":"SearchCryptos","SearchEtfs":"SearchEtfs","SearchFunds":"SearchFunds","SearchPensions":"SearchPensions","SearchStocks":"SearchStocks","GeneratePortfolioAdvanced~PortfolioOverview~PortfolioOverviewIds":"GeneratePortfolioAdvanced~PortfolioOverview~PortfolioOverviewIds","PortfolioOverview":"PortfolioOverview","PortfolioOverviewIds":"PortfolioOverviewIds","GeneratePortfolio":"GeneratePortfolio","GeneratePortfolioAdvanced":"GeneratePortfolioAdvanced","ImportPortfolio":"ImportPortfolio","LoadPortfolio":"LoadPortfolio","admin~auth":"admin~auth","admin":"admin","WelcomePage":"WelcomePage","UserAccountDetail":"UserAccountDetail","auth":"auth","forgotPassword":"forgotPassword","login":"login","register":"register"}[chunkId]||chunkId) + "." + {"BasketAsset~GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverv~e007f21c":"31d6cfe0","BasketAsset~PortfolioOverview~PortfolioOverviewIds~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchF~5638f76a":"1aa4b929","BasketAsset~SearchBenchmarks~SearchCryptos~SearchEtfs~SearchFunds~SearchPensions~SearchStocks":"ec4c7cae","BasketAsset":"31d6cfe0","GeneratePortfolio~GeneratePortfolioAdvanced~ImportPortfolio~LoadPortfolio~PortfolioOverview~Portfoli~b1a19ea9":"31d6cfe0","SearchBenchmarks":"ca8c5de5","SearchCryptos":"624e1170","SearchEtfs":"d3579353","SearchFunds":"61450fad","SearchPensions":"386635d7","SearchStocks":"5513f69a","GeneratePortfolioAdvanced~PortfolioOverview~PortfolioOverviewIds":"16d1bfef","PortfolioOverview":"1198bc98","PortfolioOverviewIds":"f3ec7840","GeneratePortfolio":"8117d141","GeneratePortfolioAdvanced":"6b86aaf7","ImportPortfolio":"ffc57ed3","LoadPortfolio":"f65583b5","admin~auth":"31d6cfe0","admin":"8ba5a3fd","WelcomePage":"266a52cb","UserAccountDetail":"5e822047","auth":"eb24edfd","chunk-1ec5f66a":"1ce41dbd","forgotPassword":"157abfc8","login":"20576d6b","register":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-b23a0edc":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
